<script lang="ts" setup>
const props = defineProps<{
  modelValue: any; // Bisa berupa tipe apapun (string, number, object, dll.)
  value: any; // Nilai yang dikaitkan dengan checkbox
  id: string;
  title: string;
}>();

// eslint-disable-next-line no-unused-vars
const emit = defineEmits<{ (e: 'update:modelValue', value: any): void }>();

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.checked) {
    emit('update:modelValue', props.value); // Emit nilai 'value' jika dicentang
  } else {
    emit('update:modelValue', null); // Emit null jika tidak dicentang (atau sesuaikan sesuai kebutuhan)
  }
};
</script>

<template>
  <div
    class="relative flex justify-start items-center gap-x-2 cursor-pointer w-auto h-auto group cool--checkbox"
  >
    <div class="cbx">
      <input
        :id="props.id"
        :checked="modelValue === props.value"
        @change="handleChange"
        type="checkbox"
        class="group-hover:border-slate-500 dark:group-hover:border-slate-400 bg-white dark:bg-gray-800"
      />
      <label :for="props.id"></label>
      <svg width="15" height="14" viewBox="0 0 15 14" fill="none">
        <path d="M2 8.36364L6.23077 12L13 2"></path>
      </svg>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="cool--checkbox-svg">
      <defs>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur"></feGaussianBlur>
          <feColorMatrix
            in="blur"
            mode="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 22 -7"
            result="goo"
          ></feColorMatrix>
          <feBlend in="SourceGraphic" in2="goo"></feBlend>
        </filter>
      </defs>
    </svg>

    <label :for="props.id" class="ml-8 cursor-pointer cbx--label">
      {{ props.title }}
    </label>
  </div>
</template>

<style scoped>
/* Masukkan coolcheckbox.css di sini atau impor CSS file terpisah */
</style>
